import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getUserRole } from "../../../shared/lib/auth/authHelper";

const cardStyle = {
  border: "1px solid rgba(255,255,255,0.1)",
  background: "rgba(255,255,255,0.04)",
  borderRadius: 18,
  padding: 18,
  color: "inherit",
  cursor: "pointer",
  textAlign: "left",
};

const Settings = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isSuperAdmin = String(getUserRole() || "").toLowerCase() === "superadmin";

  const cards = [
    {
      title: t("invoice_sync_settings_card_title", { defaultValue: "Документы и синхронизация" }),
      text: t("invoice_sync_settings_card_hint", { defaultValue: "Источник PDF, папка, расписание автоматической проверки и первичная синхронизация." }),
      route: "/menu/settings/invoice-sync",
    },
    {
      title: t("SettingsProducts", { defaultValue: "Settings Products" }),
      text: t("settings_products_hint", { defaultValue: "Manage product categories, subcategories and stock settings." }),
      route: "/menu/settings/products",
    },
    {
      title: t("crm_settings", { defaultValue: "CRM Settings" }),
      text: t("crm_settings_hint", { defaultValue: "Branding, email, AI, Google, sources and API settings." }),
      route: "/menu/settings/crm",
    },
    {
      title: t("shop_settings", { defaultValue: "Интернет-магазин" }),
      text: t("shop_settings_hint", { defaultValue: "Настройте витрину, контакты, публикацию товаров и автоматизацию заказов." }),
      route: "/menu/settings/shop",
    },
    {
      title: t("telegram_bot", { defaultValue: "Telegram Bot" }),
      text: t("telegram_bot_hint", { defaultValue: "Configure tenant Telegram assistant, lead capture and warehouse search." }),
      route: "/menu/settings/telegram",
    },
    isSuperAdmin
      ? {
          title: t("permissions", { defaultValue: "Permissions" }),
          text: t("permissions_hint", { defaultValue: "Manage roles and permissions." }),
          route: "/menu/settings/permissions",
        }
      : null,
  ].filter(Boolean);

  return (
    <div style={{ padding: 24, color: "rgba(255,255,255,0.92)" }}>
      <h1 style={{ margin: 0, fontSize: 30, fontWeight: 900 }}>
        {t("settings_title", { defaultValue: "Settings" })}
      </h1>
      <p style={{ marginTop: 8, color: "rgba(255,255,255,0.62)" }}>
        {t("settings_welcome", { defaultValue: "Choose the settings area you want to manage." })}
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: 14,
          marginTop: 20,
        }}
      >
        {cards.map((card) => (
          <button key={card.route} type="button" style={cardStyle} onClick={() => navigate(card.route)}>
            <div style={{ fontSize: 16, fontWeight: 900 }}>{card.title}</div>
            <div style={{ marginTop: 8, fontSize: 13, color: "rgba(255,255,255,0.62)", lineHeight: 1.45 }}>
              {card.text}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Settings;
